/**
 * Authentication and session DTOs shared by the API and the web client.
 * docs/ARCHITECTURE.md §4.5, §11.1, §12.3.
 */
/** Font names are validated against this fixed list — never a remote URL (§11.3). */
export const ALLOWED_FONT_FAMILIES = ['Inter', 'Roboto', 'Open Sans', 'Lato', 'system-ui'];
//# sourceMappingURL=auth.js.map